import React, { useContext, useEffect, useState } from 'react'
import { GlobalState } from '../../../../GlobalState'
import Loading from '../../../../util/Loading';

function ProductComponent({
    handProductInputOnChange,
    index,
    handleRemoveComponentClick,
    products
}) {
    const [categoryEle, setCategoryEle] = useState(null);
    const [productEle, setProductEle] = useState(null);

    const state = useContext(GlobalState);
    const [allCategories] = state.categoryAPI.allCategories;
    const [productListByCat] = state.productAPI.productListByCat;
    const [productsList] = state.productAPI.productsList;
    const [productCatId, setProductCatId] = state.productAPI.productCatId;

    const [categoryId, setCategoryId] = useState("");
    const [productData, setProductData] = useState([]);

    //For auto complete state
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectCategory, setSelectCategory] = useState("");
    const [selectShowCategory, setSelectShowCategory] = useState("");
    const suggestions = allCategories.filter(
        category => category.name.toString().toLowerCase().includes(selectCategory.toString().toLowerCase())
    )

    const [selectProduct, setSelectProduct] = useState("");
    const [selectShowProduct, setSelectShowProduct] = useState("");

    useEffect(() => {
        if (products) {
            setProductData({
                quantity: products.quantity || 0,
                purchase_price: products.purchase_price || 0,
                selling_price: products.selling_price || 0,
            })

            if (products.categoryId) {
                setSelectCategory(products.categoryId || 0);
                setCategoryId(products.categoryId || 0);

                allCategories.map(category => {
                    const category_id = products.categoryId ? products.categoryId : '1';
                    if (category.id === category_id) {
                        setSelectShowCategory(category.name || "");
                    }
                })
            }

            if (productsList.data) {
                productsList.data.map(product => {
                    const product_id = products.productId ? products.productId : "1";
                    if (product.id === product_id) {
                        setSelectProduct(product.id || 0);
                        setSelectShowProduct(product.name || "");
                    }
                })
            }
        }
    }, [productCatId, productListByCat, productsList, products, allCategories])

    // THIS FUNCTION CALLS NATIVE VALUE SETTER
    function setNativeValue(element, value) {
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

        if (valueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else {
            valueSetter.call(element, value);
        }
    }

    const handleSuggestionClick = (e, suggestion) => {
        e.preventDefault();
        setSelectCategory(suggestion.id)

        setSelectShowCategory(suggestion.name)
        setCategoryId(suggestion.id)

        setProductCatId(suggestion.id)
        handProductInputOnChange(e, 'categoryId', suggestion.id, index)
        setShowSuggestions(false)
    }

    const handleProductSuggestionClick = (e, suggestion) => {
        e.preventDefault();
        setSelectProduct(suggestion.id)

        // setNativeValue(productEle, +selectProduct + +suggestion.id);
        setSelectShowProduct(suggestion.name)
        // productEle.dispatchEvent(new Event('input', { bubbles: true }));

        handProductInputOnChange(e, 'productId', suggestion.id, index)
        setShowSuggestions(false)
    }

    const productSuggestions = productListByCat.status === 200 ? productListByCat.data.filter(product =>
        product.name.toString().toLowerCase().includes(selectProduct.toString().toLowerCase())
    ) : []

    const onChangeSelectCategory = (e, index) => {
        setSelectCategory(e.target.value);
        // handProductInputOnChange(e, index)
    }

    const onChangeSelectShowCategory = (e, index) => {
        setSelectCategory(e.target.value);
        setSelectShowCategory(e.target.value);
    }

    const onChangeSelectProduct = (e, index) => {
        setSelectProduct(e.target.value);
    }

    const onChangeSelectShowProduct = (e, index) => {
        e.preventDefault();
        setSelectShowProduct(e.target.value);
        setProductCatId(products.categoryId)
        setSelectProduct(e.target.value);
    }

    const onHandleChange = (e, index) => {
        handProductInputOnChange(e, e.target.name, e.target.value, index)
        setProductData({ ...productData, [e.target.name]: e.target.value })
    }

    return (
        <>
            {
                !productListByCat ? <Loading />
                    : <div className='list-colum'>
                        <div className="column">
                            <div>
                                <label htmlFor="categoryId">Category</label>
                                <input
                                    type="text"
                                    name="categoryId"
                                    id="categoryId"
                                    value={selectShowCategory}
                                    placeholder='Enter Category Name'
                                    onChange={(e) => onChangeSelectShowCategory(e, index)}
                                    onFocus={() => setShowSuggestions(true)}
                                    required
                                />
                                {
                                    showSuggestions && (
                                        <ul className='suggestions'>
                                            {suggestions.map(suggestion => (
                                                <li key={suggestion.id} onClick={(e) => handleSuggestionClick(e, suggestion)}>{suggestion.name}</li>
                                            ))}
                                        </ul>
                                    )
                                }
                            </div>

                            <div>
                                <label htmlFor="productId">Product Name</label>
                                <input
                                    type="text"
                                    name="product_Id"
                                    id="product_Id"
                                    value={selectShowProduct}
                                    placeholder='Enter Product Name'
                                    onChange={(e) => onChangeSelectShowProduct(e, index)}
                                    onFocus={() => setShowSuggestions(true)}
                                    required
                                />
                                {
                                    showSuggestions && (
                                        <ul className='suggestions'>
                                            {productSuggestions.map(suggestion => (
                                                <li key={suggestion.id}
                                                    onClick={(e) => handleProductSuggestionClick(e, suggestion)}>
                                                    {suggestion.name}
                                                </li>
                                            ))}
                                        </ul>
                                    )
                                }
                            </div>

                            <div>
                                <label htmlFor="quantity">Quantity</label>
                                <input
                                    type="number"
                                    name="quantity"
                                    id="quantity"
                                    value={productData.quantity || ""}
                                    placeholder='Enter Category Name'
                                    onChange={(e) => onHandleChange(e, index)}
                                    required
                                />
                            </div>

                            <div >
                                <label htmlFor="purchase_price">Purchase Price</label>
                                <input
                                    type="number"
                                    name="purchase_price"
                                    id="purchase_price"
                                    placeholder='Enter Purchase Price'
                                    value={productData.purchase_price || ""}
                                    onChange={(e) => onHandleChange(e, index)}
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="selling_price">Selling Price</label>
                                <input
                                    type="number"
                                    name="selling_price"
                                    id="selling_price"
                                    placeholder='Enter Product Name'
                                    value={productData.selling_price || ""}
                                    onChange={(e) => onHandleChange(e, index)}
                                    required
                                />
                            </div>

                            <div className='plus-btn'>
                                <button className='close-button' onClick={(e) => handleRemoveComponentClick(e, index)}><i className="uil uil-multiply"></i></button>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}

export default ProductComponent